import { Box, Button, InputBase, Typography } from "@mui/material";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateBatchHistory, updateInventoryDetail, updateinventoryDetailsEdit, updateInventoryDetailsModal, updatesearchBatchProduct, updateSelectedBatchNo } from "../../Redux/inventory";
import CustomAxios from "../../utils/CustomAxios";
import { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { BatchViewTable } from "../../sub_components/batch_view_table";
import SearchIcon from '@mui/icons-material/Search';
import { OrderDetailsModal, useGetBatchHistory } from "../globalFunctions";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

export function BatchHistory() {
    const toast = useRef(null)
    const user_id = useSelector( state => state.user.id)
    const batchHistory = useSelector(state => state.inventory.batchHistory)
    const selectedBatchNo = useSelector(state => state.inventory.selectedBatchNo)
    const [batchNo,setBatchNo] = useState()
    const dispatch = useDispatch()
    const getBatchHistory = useGetBatchHistory()

        useEffect(() => {
            getBatchHistory()
        }, [])

 const handleOpen = () => {
        dispatch(updateInventoryDetail({
            batch:[{
                product_id: "",
                available_units: "",
                units: "",
                total_units: "",
                expired_on: null,
                expire_alert: null,
                bogo_enabled:false,
                quantity: "",
            }
            ],
            place: "",
            supervisor_ids: [
                0
            ],
            details_id: '',
            purchased_on: null,
            supplier: '',
            invoice: '',
            batch_no:'',
        }));
        dispatch(updateinventoryDetailsEdit(false));
        dispatch(updateInventoryDetailsModal(true))
    };
        console.log(selectedBatchNo)

              const confirmDelete = (item) => {
                console.log(item)
                confirmDialog({
                  message: (
                    <Box sx={{ display: "flex", gap: "10px", flexDirection: "column" }}>
                      <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                        Do you want to delete this Batch
                      </Typography>
                    </Box>
                  ),
                  header: "Delete Confirmation",
                  defaultFocus: 'reject',
                  acceptClassName: 'p-button-danger',
                  accept: () => accept(item),
                });
              };
            
              const accept = async (batch) => {
                try {
                  await CustomAxios.delete(`inventory/details/delete/${batch.id}/`,{data:{admin_id:user_id,batch_delete:true}})
                  .then(() => {
                    getBatchHistory()
                    dispatch(updateSelectedBatchNo({}))
                    toast.current.show({
                          severity: "success",
                          summary: "Success",
                          detail: "Batch details deleted successfully",
                          life: 3000,
                        });
                  })
                        
                } catch (err) {
                  console.error("Error deleting delivery details", err);
                }
              };
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%", padding: "30px" }}>
            <Toast ref={toast} />
            {/* <ConfirmDialog /> */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Product Management</Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>Inventory / Batch History</Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Box sx={{ position: "relative",display:"flex",gap:"20px" }}>
                    <Box sx={{  display: "flex", flexDirection: "column", gap: "10px" }}>
                        <Dropdown onChange={(e)=>dispatch(updateSelectedBatchNo(e.target.value))} value={selectedBatchNo} options={batchHistory} optionLabel="batch_number" style={{ zIndex: "1000", height: "32px", width: "238px" }}
                            placeholder="Select Batch No" className="w-full md:w-14rem" checkmark={true} highlightOnSelect={false} />
                    </Box>
                    <Box sx={{ position: "relative" }}>
                    <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "360px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} onChange={(e) => dispatch(updatesearchBatchProduct(e.target.value))} placeholder="Search product name" />
                    <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
                </Box>
                </Box>
                <Box sx={{ display: "flex", gap: "20px" }}>
                    <Button variant="outlined" disabled={selectedBatchNo?.batch?false:true} sx={{border:"1px solid",borderColor:"secondary.border",textTransform: "none",backgroundColor:"white",opacity:selectedBatchNo?.batch?1:.5}} onClick={()=>confirmDelete(selectedBatchNo)}> <Typography sx={{color:"black",fontSize: {sm:"12px",md:"14px"}, fontWeight: "400", lineHeight: "22px",textAlign:"center",cursor:"pointer"}}> Delete Batch</Typography></Button>
                    <Button variant="contained" sx={{ textTransform: "none",height:"32px" }} onClick={handleOpen}> Add Items</Button>
                </Box>
            </Box>
            <BatchViewTable/>
            <OrderDetailsModal/>
        </Box>
    )
}